import { render } from "./package.view.vue?vue&type=template&id=0ee64e82&ts=true"
import script from "./package.view.vue?vue&type=script&lang=ts"
export * from "./package.view.vue?vue&type=script&lang=ts"

import "./package.view.vue?vue&type=style&index=0&id=0ee64e82&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__